<template>

    <v-section name="Sender" :expanded="expanded">
        <v-menu v-if="senders.length">
            <v-menu-item v-for="sender in senders"
                :key="sender.id"
                :title="sender.name"
                :subtitle="sender.email"
                :active="action.sender_id === sender.id"
                @click.native="updateSender(sender)">
            </v-menu-item>
        </v-menu>
        <v-button v-if="!project.domain && !senders.length"
            btn-label="Add Sending Domain"
            size="sm"
            btn-style="white-danger"
            btn-block
            @click.native="addDomain">
        </v-button>
        <v-button v-else-if="!senders.length"
            btn-label="Add a Sender"
            size="sm"
            btn-style="white-danger"
            btn-block
            @click.native="addSenders">
        </v-button>
    </v-section>

</template>

<script>

import Section from './Section';

export default {

    components: {
        'v-section': Section,
    },

    props: {
        expanded: {
            type: Boolean,
            default: false,
        },
    },

    computed: {

        action() {
            return this.$store.getters['builder/action'];
        },

        company() {
            return this.$store.getters.company;
        },

        senders() {
            return this.project.senders;
        },

    },

    methods: {

        updateSender(sender) {
            let action = this.action
            if (action.sender_id === sender.id) {
                this.$set(action, 'sender_id', null);
            } else {
                this.$set(action, 'sender_id', sender.id);
            }
            this.$store.commit('builder/setAction', action);
        },

        addDomain() {
            this.$store.commit('showModal', false);
            this.$router.push({ name: 'settings-domain' });
        },

        addSenders() {
            this.$store.commit('showModal', false);
            this.$router.push({ name: 'settings-senders' });
        },

    },

}

</script>